// Google Maps (the app on mobile) driving directions to a machine's last known
// position. Returns null when the location is missing or incomplete.
export const getDirectionsUrl = location =>
  location && typeof location.lat === 'number' && typeof location.lng === 'number'
    ? `https://www.google.com/maps/dir/?api=1&destination=${location.lat},${location.lng}`
    : null;
